import { UnitService } from "@propertelligent/client-api";
import { GET_ALL_UNIT, GET_ERRORS } from "./types";

export const getTenantList =
  (id, fulllyQualifiedFilter) => async (dispatch) => {
    try {
      UnitService.getApiUnitPropertylist(
        parseInt(id),
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        fulllyQualifiedFilter,
      ).then((response) => {
        dispatch({ type: GET_ALL_UNIT, payload: response.success });
      });
    } catch (error) {
      dispatch({ type: GET_ERRORS, payload: response.errors });
    }
  };
